import { useStoreActions } from '~/contexts';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useLocaleKeys } from '~/i18n';
export function useRenameAgreement() {
    const { api } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: errorTexts } = useLocaleKeys('errors');
    const { mutateAsync } = useMutationState({
        mutationFn: (param)=>{
            let { id, title } = param;
            return api.relationship.updateTitle(id, title);
        },
        withPageLoader: true,
        mutationName: 'rename-agreement',
        toasts: {
            successMessage: commonTexts.toasts.changesSavedSuccessfully(),
            successTestId: 'edit-agr-success',
            errorMessage: errorTexts.unexpected(),
            errorTestId: 'edit-agr-error'
        }
    });
    return {
        renameAgreement: async (param)=>{
            let { id, title, onSuccess } = param;
            try {
                await mutateAsync({
                    id,
                    title
                });
            } catch (unused) {
                return;
            }
            await onSuccess();
        }
    };
}
